export const modulesRequest = async (path, method = 'GET') => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${path}`, {
        method,
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            Authorization: sessionStorage.getItem('agronetToken'),
            Local: localStorage.getItem('lang') || 'en'
        }
    });
    if (!response.ok) throw new Error(String(response.status));
    return response.json();
};

// Modules the panel knows how to describe; others are listed by their type.
const knownModules = {
    COMMUNITY_TEMPERATURE_MAP: {
        name: 'Community temperature map', hasPaid: true, order: 1,
        description: 'Temperature map from community sensors in the mobile app. Without "Paid" the map is 2 hours late and frost alerts are off.'
    },
    GREENCLOUD_VIEW: {name: 'Greencloud', hasPaid: false, order: 2, description: 'Greencloud view in the mobile app.'}
};
// The backend always reports this one as active; it cannot be switched here.
const hiddenModules = ['BASIC_AGRONET_MAP'];

export const visibleModules = modules => {
    const seen = new Set();
    return (modules || [])
        .filter(module => !hiddenModules.includes(module.moduleType))
        .filter(module => !seen.has(module.moduleType) && seen.add(module.moduleType))
        .map(module => {
            const known = knownModules[module.moduleType] || {};
            return {
                moduleType: module.moduleType,
                name: known.name || module.moduleType,
                description: known.description || '',
                hasPaid: !!known.hasPaid,
                active: !!module.moduleActivated,
                paid: !!module.paid,
                order: known.order || 99
            };
        })
        .sort((a, b) => a.order - b.order);
};
